import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod";

import { useSquadActions } from "@/hooks/squads/use-squad-actions";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Form } from "@/components/ui/form";
import { FormInput } from "@/components/campos-formulario/novos/FormInput";
import { FormTextarea } from "@/components/campos-formulario/novos/FormTextarea"; // Assumindo que exista

const createSquadSchema = z.object({
  nome: z.string().min(3, "O nome deve ter no mínimo 3 caracteres"),
  descricao: z.string().optional(),
});

type CreateSquadFormData = z.infer<typeof createSquadSchema>;

interface SquadCreateFormDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function SquadCreateFormDialog({ open, onOpenChange }: SquadCreateFormDialogProps) {
  const { createSquad, isCreating } = useSquadActions();

  const form = useForm<CreateSquadFormData>({
    resolver: zodResolver(createSquadSchema),
    defaultValues: { nome: "", descricao: "" },
  });

  const handleSubmit = async (data: CreateSquadFormData) => {
    try {
      if (!data.nome) return;

      await createSquad({ nome: data.nome, descricao: data.descricao });
      form.reset();
      onOpenChange(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(val) => {
        onOpenChange(val);
        if (!val) form.reset();
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Novo Squad</DialogTitle>
        </DialogHeader>

        <Form {...form}>
          <form onSubmit={form.handleSubmit(handleSubmit)} className="space-y-4">
            <Controller
              control={form.control}
              name="nome"
              render={({ field }) => (
                <FormInput
                  {...field}
                  label="Nome do Squad"
                  placeholder="Ex: Squad Alpha"
                  value={field.value || ""}
                  onChange={(e) => field.onChange(e.target.value)}
                />
              )}
            />

            <Controller
              control={form.control}
              name="descricao"
              render={({ field }) => (
                <FormTextarea
                  {...field}
                  label="Descrição"
                  placeholder="Descrição curta (opcional)"
                  value={field.value || ""}
                  onChange={(e) => field.onChange(e.target.value)}
                />
              )}
            />

            <DialogFooter>
              <Button
                type="button"
                variant="outline"
                onClick={() => onOpenChange(false)}
                disabled={isCreating}
              >
                Cancelar
              </Button>
              <Button type="submit" disabled={isCreating}>
                {isCreating ? "Salvando..." : "Salvar Squad"}
              </Button>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
}
